import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChartCardComponent } from '../chart-card/chart-card.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { StatusCardComponent } from '../status-card/status-card.component';
import { WaveQualityStatusIndicator } from './wave-quality-status.model';
import { ChartHeader } from '@charts';

@Component({
  selector: 'ui-wave-quality-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChartCardComponent,
    TranslocoDirective,
    StatusCardComponent,
    ChartHeader,
  ],
  template: `
    <ng-container *transloco="let t">
      <ui-chart-card>
        <div class="flex flex-col justify-start gap-y-4 w-full">
          <chart-header
            [title]="t('CHARTS.WAVE_QUALITY.TITLE')"
            [subtitle]="t('CHARTS.WAVE_QUALITY.SUBTITLE')"
          />
          @if (!indicators().length) {
            <span class="text-neutral-6 text-base">{{ t('CHARTS.WAVE_QUALITY.ERROR_MESSAGE') }}</span>
          }
          <div class="grid grid-cols-5 gap-2 w-full">
            @for (item of indicators(); track item.label) {
              <ui-status-card
                class="w-full"
                [label]="t(item.label)"
                [isValid]="item.valid"
              />
            }
          </div>
        </div>
      </ui-chart-card>
    </ng-container>
  `,
})
export class WaveQualityStatusComponent {
  indicators = input.required<WaveQualityStatusIndicator[]>();
}
